import {
  AppointmentParticipantResponse,
  AppointmentResponse
} from "@9amhealth/openapi";
import { Button } from "@9amhealth/shared";
import {
  ScheduleAppointmentTypes,
  SchedulerReconnectStatus
} from "molecule/scheduler/SchedulerBloc";
import { FC } from "react";
import translate from "src/lib/translate";
import { TranslationKey } from "src/types/translationKey";
import { AppQueryPopupsController } from "../AppQueryPopups/AppQueryPopupsBloc";
import Loader from "../Loader/Loader";
import ProviderReconnectModal from "../ProviderReconnectModal/ProviderReconnectModal";
import Translate from "../Translate/Translate";
import { ErrorInfo } from "./AppointmentScheduler.styled";

const SchedulerEarlyState: FC<{
  error: TranslationKey | undefined;
  appointmentType: ScheduleAppointmentTypes | undefined;
  previousProvider: AppointmentParticipantResponse | null | undefined;
  rescheduleAppointment: AppointmentResponse | undefined;
  requestProviders: string[] | false | undefined;
  onSetRequestProviders: (
    providers: string[] | false,
    action: SchedulerReconnectStatus
  ) => void;
}> = ({
  error,
  appointmentType,
  previousProvider,
  rescheduleAppointment,
  requestProviders,
  onSetRequestProviders
}) => {
  if (error) {
    return (
      <ErrorInfo>
        <h4>{translate(error)}</h4>
        <Button
          hideArrow
          theme="charcoal"
          onPress={(): void => AppQueryPopupsController.closePopup()}
        >
          <Translate msg="close" />
        </Button>
      </ErrorInfo>
    );
  }

  const isLoading =
    !appointmentType ||
    (typeof previousProvider === "undefined" && !rescheduleAppointment);

  if (isLoading) {
    return (
      <Loader active={true} fullPage bg="transparent" fixed hideProgress />
    );
  }

  const showProviderReconnectModal =
    typeof requestProviders === "undefined" &&
    previousProvider &&
    !rescheduleAppointment;

  if (showProviderReconnectModal) {
    return (
      <ProviderReconnectModal
        providerName={previousProvider.displayName || ""}
        providerId={previousProvider.userId}
        onYes={() =>
          onSetRequestProviders([previousProvider.userId], "accepted")
        }
        onNo={() => onSetRequestProviders(false, "rejected")}
      />
    );
  }

  return null;
};

export default SchedulerEarlyState;
